"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Icon } from "@/components/formatters/MXPIcon";
import type { FilterGroup, FilterOption, SortOption } from "./types";
import type { FilterableCardsLabelsFields } from "@/queries/fragments/filterableCardsLabelsFragment";
interface MobileFilterDrawerProps {
  isOpen: boolean;
  mode: "filter" | "sort";
  filterGroups: FilterGroup[];
  activeFilters: Record<string, string[]>;
  sortOptions: SortOption[];
  currentSort: string;
  onFilterChange: (groupId: string, values: string[]) => void;
  onSortChange: (value: string) => void;
  onClearAll: () => void;
  onClose: () => void;
  labels?: FilterableCardsLabelsFields | null;
}
const CHECKBOX_BASE = "min-w-[18px] min-h-[18px] w-[18px] h-[18px] cursor-pointer appearance-none rounded border border-gray-m4 bg-transparent pointer-events-none shrink-0";
const checkedStyle: React.CSSProperties = {
  backgroundColor: "#0063A3",
  borderColor: "#0063A3",
  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8l3 3 5-6'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "70%"
};
const RADIO_BASE = "min-w-[18px] min-h-[18px] w-[18px] h-[18px] appearance-none rounded-full border-2 border-gray-m4 bg-transparent pointer-events-none shrink-0";
const radioCheckedStyle: React.CSSProperties = {
  borderColor: "#0063A3",
  boxShadow: "inset 0 0 0 3px #fff, inset 0 0 0 8px #0063A3"
};
const MobileFilterList = t0 => {
  const $ = _c(11);
  const {
    group,
    activeValues,
    onToggle,
    onDrillDown
  } = t0;
  let t1;
  if ($[0] !== activeValues || $[1] !== group.options || $[2] !== onDrillDown || $[3] !== onToggle) {
    let t2;
    if ($[5] !== activeValues || $[6] !== onDrillDown || $[7] !== onToggle) {
      t2 = option => {
        const hasChildren = option.children && option.children.length > 0;
        return <li key={option.value} className="flex items-center gap-3 py-3 px-4 border-b border-gray-m1 cursor-pointer text-gray-m7 text-base hover:bg-gray-m1" onClick={() => hasChildren ? onDrillDown(option) : onToggle(option.value)}>{!hasChildren && <input type="checkbox" className={CHECKBOX_BASE} style={activeValues.includes(option.value) ? checkedStyle : undefined} checked={activeValues.includes(option.value)} readOnly={true} />}<span className={activeValues.includes(option.value) ? "text-blue-trmb font-semibold" : ""}>{option.label}</span>{hasChildren && <span className="ml-auto"><Icon type="t2u-chevron-right" size={12} /></span>}</li>;
      };
      $[5] = activeValues;
      $[6] = onDrillDown;
      $[7] = onToggle;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = group.options.map(t2);
    $[0] = activeValues;
    $[1] = group.options;
    $[2] = onDrillDown;
    $[3] = onToggle;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <ul className="list-none m-0 p-0">{t1}</ul>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
const MobileSubList = t0 => {
  const $ = _c(13);
  const {
    parentOption,
    activeValues,
    onToggle,
    onBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon type="t2u-chevron-right" size={12} rotateDeg="180" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onBack || $[2] !== parentOption.label) {
    t2 = <button className="flex items-center gap-2 py-3 px-4 text-gray-m9 text-base font-bold cursor-pointer bg-transparent border-none border-b border-gray-m2 w-full text-left" onClick={onBack}>{t1}{parentOption.label}</button>;
    $[1] = onBack;
    $[2] = parentOption.label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeValues || $[5] !== onToggle || $[6] !== parentOption.children) {
    t3 = parentOption.children?.map(child => <li key={child.value} className="flex items-center gap-3 py-3 px-6 border-b border-gray-m1 cursor-pointer text-gray-m7 text-base hover:bg-gray-m1" onClick={() => onToggle(child.value)}><input type="checkbox" className={CHECKBOX_BASE} style={activeValues.includes(child.value) ? checkedStyle : undefined} checked={activeValues.includes(child.value)} readOnly={true} /><span className={activeValues.includes(child.value) ? "text-blue-trmb font-semibold" : ""}>{child.label}</span></li>);
    $[4] = activeValues;
    $[5] = onToggle;
    $[6] = parentOption.children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <ul className="list-none m-0 p-0">{t3}</ul>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div>{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export const MobileFilterDrawer = t0 => {
  const $ = _c(58);
  const {
    isOpen,
    mode,
    filterGroups,
    activeFilters,
    sortOptions,
    currentSort,
    onFilterChange,
    onSortChange,
    onClearAll,
    onClose,
    labels
  } = t0;
  const [activeGroupId, setActiveGroupId] = useState(null);
  const [drillDownOption, setDrillDownOption] = useState(null);
  let t1;
  if ($[0] !== activeFilters || $[1] !== onFilterChange) {
    t1 = (groupId, value) => {
      const current = activeFilters[groupId] || [];
      const next = current.includes(value) ? current.filter(v => v !== value) : [...current, value];
      onFilterChange(groupId, next);
    };
    $[0] = activeFilters;
    $[1] = onFilterChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleToggle = t1;
  let t2;
  if ($[3] !== onClose) {
    t2 = () => {
      setActiveGroupId(null);
      setDrillDownOption(null);
      onClose();
    };
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClose = t2;
  if (!isOpen) {
    return null;
  }
  const t3 = mode === "filter" ? labels?.labelForFilters || "Filters" : labels?.labelForSortBy || "Sort By";
  let t4;
  if ($[5] !== t3) {
    t4 = <h3 className="text-lg font-bold text-gray-m9 m-0">{t3}</h3>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== labels?.labelForClearAll || $[8] !== mode || $[9] !== onClearAll) {
    t5 = mode === "filter" && <button className="text-blue-trmb text-sm font-semibold cursor-pointer bg-transparent border-none p-0" onClick={onClearAll}>{labels?.labelForClearAll || "Clear All"}</button>;
    $[7] = labels?.labelForClearAll;
    $[8] = mode;
    $[9] = onClearAll;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = labels?.labelForClose || "Close";
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon type="t2u-close" size={16} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleClose || $[13] !== t6) {
    t8 = <button className="w-8 h-8 flex items-center justify-center cursor-pointer bg-transparent border-none text-gray-m9" onClick={handleClose} aria-label={t6}>{t7}</button>;
    $[12] = handleClose;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t8) {
    t9 = <div className="flex items-center gap-4">{t5}{t8}</div>;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <div className="flex items-center justify-between px-4 py-3 border-b border-gray-m2 shrink-0">{t4}{t9}</div>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== currentSort || $[22] !== handleClose || $[23] !== mode || $[24] !== onSortChange || $[25] !== sortOptions) {
    t11 = mode === "sort" && <ul className="list-none m-0 p-0">{sortOptions.map(option => <li key={option.value} className="flex items-center gap-3 py-3 px-4 border-b border-gray-m1 cursor-pointer text-gray-m7 text-base hover:bg-gray-m1" onClick={() => {
        onSortChange(option.value);
        handleClose();
      }}><input type="radio" className={RADIO_BASE} style={currentSort === option.value ? radioCheckedStyle : undefined} checked={currentSort === option.value} readOnly={true} /><span className={currentSort === option.value ? "text-blue-trmb font-semibold" : ""}>{option.label}</span></li>)}</ul>;
    $[21] = currentSort;
    $[22] = handleClose;
    $[23] = mode;
    $[24] = onSortChange;
    $[25] = sortOptions;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== activeFilters || $[28] !== activeGroupId || $[29] !== drillDownOption || $[30] !== filterGroups || $[31] !== mode) {
    t12 = mode === "filter" && !activeGroupId && !drillDownOption && <ul className="list-none m-0 p-0">{filterGroups.map(group => {
        const count = (activeFilters[group.id] || []).length;
        return <li key={group.id} className="flex items-center justify-between py-3 px-4 border-b border-gray-m1 cursor-pointer text-gray-m9 text-base font-semibold hover:bg-gray-m1" onClick={() => setActiveGroupId(group.id)}><span>{group.label}{count > 0 && <span className="ml-2 text-blue-trmb text-sm font-normal">({count})</span>}</span><Icon type="t2u-chevron-right" size={12} /></li>;
      })}</ul>;
    $[27] = activeFilters;
    $[28] = activeGroupId;
    $[29] = drillDownOption;
    $[30] = filterGroups;
    $[31] = mode;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== activeFilters || $[34] !== activeGroupId || $[35] !== drillDownOption || $[36] !== filterGroups || $[37] !== handleToggle || $[38] !== mode) {
    t13 = mode === "filter" && activeGroupId && !drillDownOption && <div><button className="flex items-center gap-2 py-3 px-4 text-gray-m9 text-base font-bold cursor-pointer bg-transparent border-none border-b border-gray-m2 w-full text-left" onClick={() => setActiveGroupId(null)}><Icon type="t2u-chevron-right" size={12} rotateDeg="180" />{filterGroups.find(g => g.id === activeGroupId)?.label}</button><MobileFilterList group={filterGroups.find(g_0 => g_0.id === activeGroupId)} activeValues={activeFilters[activeGroupId] || []} onToggle={value_0 => handleToggle(activeGroupId, value_0)} onDrillDown={option_0 => setDrillDownOption(option_0)} /></div>;
    $[33] = activeFilters;
    $[34] = activeGroupId;
    $[35] = drillDownOption;
    $[36] = filterGroups;
    $[37] = handleToggle;
    $[38] = mode;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== activeFilters || $[41] !== activeGroupId || $[42] !== drillDownOption || $[43] !== handleToggle || $[44] !== mode) {
    t14 = mode === "filter" && drillDownOption && <MobileSubList parentOption={drillDownOption} activeValues={activeFilters[activeGroupId || ""] || []} onToggle={value_1 => handleToggle(activeGroupId || "", value_1)} onBack={() => setDrillDownOption(null)} />;
    $[40] = activeFilters;
    $[41] = activeGroupId;
    $[42] = drillDownOption;
    $[43] = handleToggle;
    $[44] = mode;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t11 || $[47] !== t12 || $[48] !== t13 || $[49] !== t14) {
    t15 = <div className="flex-1 overflow-y-auto">{t11}{t12}{t13}{t14}</div>;
    $[46] = t11;
    $[47] = t12;
    $[48] = t13;
    $[49] = t14;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  const t16 = labels?.labelForApply || "Apply";
  let t17;
  if ($[51] !== handleClose || $[52] !== t16) {
    t17 = <div className="shrink-0 px-4 py-3 border-t border-gray-m2"><button className="w-full py-3 bg-blue-trmb text-white text-base font-bold rounded-lg border-none cursor-pointer hover:bg-blue-navy" onClick={handleClose}>{t16}</button></div>;
    $[51] = handleClose;
    $[52] = t16;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== t10 || $[55] !== t15 || $[56] !== t17) {
    t18 = <div className="fixed inset-0 z-50 flex flex-col bg-white">{t10}{t15}{t17}</div>;
    $[54] = t10;
    $[55] = t15;
    $[56] = t17;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  return t18;
};